import { Program } from "./Program";
import { Store } from "./Store";

export interface LabelTemplate {
    id: number;
    active: boolean;
    name: string;
    template: string;
    type: LabelTemplateType;
    /**
     * Printer resolution the template's ZPL is authored for. ZPL positions everything in dots, so
     * a template only renders at its intended physical size on a printer of this resolution.
     */
    dpi: number;
    stores?: Store[];
    programs?: Program[];
    states?: string[];
}

export class LabelTemplate {
    constructor(obj?: Partial<LabelTemplate>) {
        if (obj) Object.assign(this, obj);
    }
}

export enum LabelTemplateType {
    bottleLabel,
    bottleLabelQrCode
}